<div class="main-container">
    <app-header [showHeader]="userLogged"></app-header>
    <router-outlet></router-outlet>
    <app-loading *ngIf="userLogged"></app-loading>
    <app-footer [showFooter]="userLogged"></app-footer>
</div>
<app-notification></app-notification>
